export default __webpack_public_path__ + "static/media/skills-dark.797b633a.svg";